module.exports = __webpack_public_path__ + "static/media/js.144d6a27.png";